import {
  UseMutationResult,
  useMutation,
  useQueryClient
} from '@tanstack/react-query'
import {
  DeleteWorkspaceMemberMutation,
  DeleteWorkspaceMemberMutationVariables
} from '~workspace/types/__generated/gql/graphql'
import { graphierQL } from 'utils'
import {
  GetWorkspaceByIdResults,
  getWorkspaceByIdQueryKey
} from './useGetWorkspaceById'
import { useRouter } from 'next/router'

const query = /* GraphQL */ `
  mutation DeleteWorkspaceMember($id: ID!) {
    deleteWorkspaceMember(id: $id) {
      id
    }
  }
`

export type DeleteWorkspaceMemberResults =
  DeleteWorkspaceMemberMutation['deleteWorkspaceMember']
export type DeleteWorkspaceMemberVariables =
  DeleteWorkspaceMemberMutationVariables

export const useDeleteWorkspaceMember = (): UseMutationResult<
  DeleteWorkspaceMemberResults,
  Error,
  DeleteWorkspaceMemberVariables
> => {
  const {
    query: { workspaceId }
  } = useRouter()
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['deleteWorkspaceMember'],
    mutationFn: (vars: DeleteWorkspaceMemberVariables) =>
      graphierQL<DeleteWorkspaceMemberMutation, DeleteWorkspaceMemberVariables>(
        { query, useToken: true, variables: vars }
      ).then((res) => res.deleteWorkspaceMember),
    onSuccess: (data) => {
      queryClient.setQueryData<GetWorkspaceByIdResults>(
        getWorkspaceByIdQueryKey(String(workspaceId)),
        (prev) => {
          if (!prev) return
          return {
            ...prev,
            memberCollection: {
              items: prev?.memberCollection?.items?.filter(
                (member) => member?.id !== data.id
              ),
              total: prev?.memberCollection?.total
                ? prev?.memberCollection?.total - 1
                : 0
            }
          }
        }
      )
    }
  })
}
